import "./style.scss";

export const Game = ({ component }) => {
  return <div className="game-page">{component}</div>;
};
